module.exports = {"210211001":"周水子街道","210211002":"椒金山街道","210211004":"甘井子街道","210211006":"南关岭街道","210211007":"泡崖街道","210211008":"中华路街道","210211009":"兴华街道","210211010":"机场街道","210211014":"辛寨子街道","210211015":"红旗街道","210211016":"凌水街道","210211017":"大连湾街道","210211018":"泉水街道","210211019":"革镇堡街道","210211020":"营城子街道","210211021":"七贤岭街道","210211400":"大连华侨果树农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210211.json
// module id = 469
// module chunks = 0